import styled from 'styled-components';
import { FlexColumn } from '@elementary/common-ui/components';
import YamlFormField from './YamlFormField';
import {
  EMPTY_YAML_FORM_RESOURCE_OPTIONS,
  YamlFormField as YamlFormFieldDescriptor,
  YamlFormResourceOptions,
  YamlFormValues,
} from './types';

const ScrollArea = styled(FlexColumn)`
  flex: 1;
  min-height: 0;
  overflow: auto;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  align-items: center;
  column-gap: 16px;
  row-gap: 24px;
  width: 100%;
  max-width: 960px;
  margin-inline: auto;
  padding-right: ${({ theme }) => theme.spacing(4)};
  padding-bottom: ${({ theme }) => theme.spacing(3)};
`;

type Props = {
  fields: YamlFormFieldDescriptor[];
  values: YamlFormValues;
  onChange: (values: YamlFormValues) => void;
  resourceOptions?: YamlFormResourceOptions;
};

const YamlForm = ({
  fields,
  values,
  onChange,
  resourceOptions = EMPTY_YAML_FORM_RESOURCE_OPTIONS,
}: Props) => (
  <ScrollArea>
    <FormGrid>
      {fields.map((field) => (
        <YamlFormField
          key={field.path.join('.')}
          field={field}
          values={values}
          onChange={onChange}
          resourceOptions={resourceOptions}
        />
      ))}
    </FormGrid>
  </ScrollArea>
);

export default YamlForm;
